import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Logo from "@/components/Logo";
import Button from "@/components/Button";
import { Field } from "@/components/Form";
import { Eyebrow, Headline } from "@/components/Editorial";
import { Spinner } from "@/components/Loader";
import { toast } from "@/components/Toast";
import PortalToggle from "@/components/PortalToggle";
import { useAffiliateAuth } from "@/lib/affiliateAuth";
import { C } from "@/lib/brand";

export default function AffiliateSignIn() {
  const { login } = useAffiliateAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email || !password) {
      toast("Enter your email and password.", "error");
      return;
    }
    setLoading(true);
    try {
      await login(email.trim().toLowerCase(), password);
      navigate("/affiliates/dashboard", { replace: true });
    } catch (err) {
      toast(err.detail || "We couldn't sign you in. Check your details or reset your password.", "error");
      setLoading(false);
    }
  };

  return (
    <div data-testid="affiliate-signin-page" style={{ minHeight: "100vh", background: C.cream, color: C.ink }}>
      <header style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "18px 24px", borderBottom: `1px solid ${C.warmGray3}` }}>
        <Link to="/affiliates" style={{ display: "flex", alignItems: "center", gap: 10, textDecoration: "none" }}>
          <Logo size={22} />
          <span style={{ fontSize: 10, fontWeight: 800, letterSpacing: "0.2em", color: C.warmGray }}>
            · AFFILIATE
          </span>
        </Link>
        <Link to="/affiliates" style={{ fontSize: 11, fontWeight: 800, letterSpacing: "0.18em", color: C.warmGray, textDecoration: "none" }}>
          ← BACK
        </Link>
      </header>

      <div style={{ maxWidth: 480, margin: "0 auto", padding: "72px 24px 120px" }}>
        <Eyebrow color={C.peachDeep}>★ AFFILIATE PORTAL</Eyebrow>
        <Headline before="WELCOME" italic="back." size={56} className="mt-6" />

        <div style={{ marginTop: 28 }}>
          <PortalToggle active="affiliate" />
        </div>

        <form onSubmit={submit} style={{ marginTop: 24, padding: 32, background: C.bone }}>
          <Field
            label="EMAIL"
            type="email"
            name="email"
            id="affiliate-signin-email"
            autoComplete="username"
            value={email}
            onChange={setEmail}
            placeholder="you@example.com"
            testId="affiliate-signin-email"
            autoFocus
            required
          />
          <Field
            label="PASSWORD"
            type="password"
            name="password"
            id="affiliate-signin-password"
            autoComplete="current-password"
            value={password}
            onChange={setPassword}
            placeholder="••••••••"
            testId="affiliate-signin-password"
            required
          />

          <div style={{ marginTop: 22 }}>
            <Button
              variant="primary"
              size="lg"
              block
              testId="affiliate-signin-btn"
              onClick={submit}
              disabled={loading}
            >
              {loading ? <Spinner color={C.cream} /> : "SIGN IN →"}
            </Button>
          </div>

          <div style={{ marginTop: 16, textAlign: "center" }}>
            <a
              href="mailto:affiliates@voya9.com?subject=Affiliate%20password%20reset"
              data-testid="affiliate-forgot-password"
              style={{ fontSize: 13, color: C.warmGray, fontFamily: '"Instrument Serif", Georgia, serif', fontStyle: "italic", textDecoration: "underline" }}
            >
              Forgot password?
            </a>
          </div>
        </form>

        <div style={{ marginTop: 32, padding: 22, background: C.peach, color: C.peachDark, textAlign: "center" }}>
          <div style={{ fontSize: 13, color: C.peachDark, marginBottom: 6 }}>Not yet an affiliate?</div>
          <Link
            to="/affiliates/apply"
            data-testid="affiliate-signin-apply"
            style={{ fontSize: 12, fontWeight: 800, letterSpacing: "0.2em", color: C.ink, textDecoration: "none" }}
          >
            APPLY TO JOIN →
          </Link>
        </div>
      </div>
    </div>
  );
}
